<cp-page *ngIf="config$ | async as config" [header]="isServerCompatible(config) ? 'Login.header' : 'Login.errorHeader'" type="account">
  <ng-container *ngIf="isServerCompatible(config); else notCompatible">
    <div class="login-module">
      <form class="login-module-user" [formGroup]="form">
        <ng-container *ngIf="(config.loginOption === loginOption.MemoQ) || (config.loginOption === loginOption.Both)">
          <cp-input inputId="email" type="email" class="user-input"
                    [cpFormControl]="emailControl" [validate]="validate"
                    placeholder="Login.emailAddress" large="true">
          </cp-input>

          <cp-input inputId="password" type="password" class="user-input"
                    [cpFormControl]="passwordControl" [validate]="validate"
                    placeholder="Login.password" large="true">
          </cp-input>

          <cp-button type="submit" class="login-button large-button" large="true" label="Login.login" (click)="login()"></cp-button>
        </ng-container>

        <cp-validation-error *ngIf="serverError" class="server-error" [validate]="serverError" [errors]="serverError" [collapseMargin]="false">
        </cp-validation-error>

        <div class="login-extra-links" *ngIf="(config.loginOption === loginOption.MemoQ) || (config.loginOption === loginOption.Both)">
          <div *ngIf="config.registrationEnabled">
            <cp-link [route]="['/account', 'register']" label="Login.signUp"></cp-link>
          </div>
          <div class="forget-password">
            <cp-link [route]="['/account', 'reset-password']" label="Login.forgotPassword"></cp-link>
          </div>
        </div>

        <div class="login-extra-links-oidc" *ngIf="(config.loginOption === loginOption.SSO)">
          <div *ngIf="config.registrationEnabled">
            <span class="login-extra-links-text-oidc">{{ "Login.noAccountYet" | translate }}</span>
            <cp-link [route]="['/account', 'register']" label="Login.signUp"></cp-link>
          </div>
        </div>

        <div class="oidc-options" *ngIf="(config.loginOption === loginOption.SSO) || (config.loginOption === loginOption.Both)">
          <p *ngIf="(config.loginOption === loginOption.Both)"><span>Or</span></p>
          <ul>
            <li *ngFor="let idp of config.identityProviderInfos">
              <button label="idp.name" (click)="oidcAuth(idp.name)">
                <img src="{{ idp.buttonIconUrl }}" alt="{{ idp.displayName }}" />
                {{ prefixLabel | translate }} {{ idp.displayName }}
              </button>
            </li>
          </ul>
        </div>

        <div class="hadUnsupportedLanguage-text" *ngIf="hadUnsupportedLanguage$ | async">
          {{ "Login.hadUnsupportedLanguage" | translate }}
        </div>
      </form>
    </div>
  </ng-container>
  <ng-template #notCompatible>
    <div class="error">
      <div class="error-text">
        {{ "Login.errorIncompatibleVersions" | translate:{ cpVer: config.version.customerPortal, mqsVer: config.version.memoQ } }}
      </div>
    </div>
  </ng-template>
</cp-page>
